import React, { useEffect, useState } from "react";
import CourseHeader from "../header/index";
import { Col, Row } from "react-bootstrap";
import {
    Link,
    useLocation,
    // useLocation,
    useParams
} from "react-router-dom";
import '../Journal/journal.css'
import Footer from "../footer";
// import InnerBanner from "../../assets/img/inner-banner.jpg";
import StudentSideBar from "../student/sidebar";

// import {
//     useDispatch
//     // , useSelector
// } from "react-redux";
// import { SpissuesgetById } from "../../Redux/SpecialIssues/specialissueSlice";
import Bannerpage from "../Banner";
// import queryString from 'query-string';
// import moment from "moment";
import { Html, Pdf } from "../imagepath";
import axios from "axios";

const AuthorInfoJournal = () => {

    // const { spIssue } = useSelector((state) => state.spIssueData)
    // const location = useLocation();
    // const query = queryString.parse(location.search);

    // Parse the article data back to an object
    // const article = query.article ? JSON.parse(query.article) : null;

    const [article, setArticle] = useState({})
    console.log(article, "adddoi")

    const location = useLocation();
    console.log(location, 'vcghvsdgcvsd');

    const [authorDetails, setAuthorDetails] = useState({
        name: location?.state?.author?.author_name || '',
        department: location?.state?.author?.department || '',
        college: location?.state?.author?.institue_college || '',
        // university: location?.state?.author?.university_name_1 || '',
        country: location?.state?.author?.country || '',
        university_name_1: location?.state?.author?.university_name_1 || '',
        designation: location?.state?.author?.designation || '',
        telephone: location?.state?.author?.telephone || '',
        qualification: location?.state?.author?.qualification || '',
        email_1: location?.state?.author?.email_1 || '',
        address: location?.state?.author?.address || '',
    })
    console.log(authorDetails, 'sbcshcgsbdhcbsd');

    const handleAuthorDetails = (data) => {
        console.log(data, 'avgacvsadgc');

        setAuthorDetails({
            name: data?.author_name || '',
            department: data?.department || '',
            college: data?.institue_college || '',
            // university: location?.state?.author?.university_name_1 || '',
            country: data?.country || '',
            university_name_1: data?.university_name_1 || '',
            designation: data?.designation || '',
            telephone: data?.telephone || '',
            qualification: data?.qualification || '',
            email_1: data?.email_1 || '',
            address: data?.address || '',
        })
    }

    // const dispatch = useDispatch();
    const { ArticleHtml, type } = useParams();

    const getArchiveDetailesBySlug = () => {
        axios.get(`${process.env.REACT_APP_URL}/articleDetails/${ArticleHtml}`)
            .then((res) => {
                console.log(res?.data)
                setArticle(res?.data?.data?.[0])
            })
            .catch((err) => {
                console.log(err)
            })
    }

    console.log(article, "Parsed article");


    useEffect(() => {
        // dispatch(SpissuesgetById(slug));
        getArchiveDetailesBySlug()
    }, [])

    // Affiliation mapping logic - create for each article
    const getAffiliationMap = (article) => {
        const affiliationMap = new Map();
        article?.authors?.forEach((author) => {
            author?.author_anchor_affiliation?.forEach((affiliation) => {
                const key = `${affiliation?.department}|${affiliation?.university_name_1}|${affiliation?.country}`;
                if (!affiliationMap.has(key)) {
                    affiliationMap.set(key, { number: affiliationMap.size + 1, affiliation });
                }
            });
        });
        return affiliationMap;
    };

    // const { spIssue } = useSelector((state) => state.spIssueData)
    // const location = useLocation();
    // const query = queryString.parse(location.search);

    // // Parse the article data back to an object
    // const article = query.article ? JSON.parse(query.article) : null;

    // console.log(article, "Parsed article");

    // const dispatch = useDispatch();
    const { slug } = useParams();

    // useEffect(() => {
    //     dispatch(SpissuesgetById(slug));
    // }, [])

    return (
        <>
            <CourseHeader activeMenu={"CourseDetails"} />
            {/* <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <div className="breadcrumb-list">
                                <nav aria-label="breadcrumb" className="page-breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Courses
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            All Courses
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            The Complete Web Developer Course 2.0
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <Bannerpage name={slug} />

            <div className="container p-5">
                <Row>
                    <StudentSideBar />
                    <Col style={{ backgroundColor: "#fff" }}>
                        {/* <div className="cardb" style={{ paddingTop: 10 }}>
                            <Row>
                                <Col>
                                    <label>{article?.article_types?.[0]?.name} - {volume}</label>
                                </Col>
                                <Col>
                                    <div style={{ textAlign: 'right' }}>
                                        <Link
                                            to={article?.pdf_url}
                                            target="_blank"
                                        >
                                            <button>
                                                View PDF
                                            </button>
                                        </Link> &nbsp; <PdfDownloader pdfUrl={article?.pdf_url} fileName="document.pdf">Download PDF</PdfDownloader>
                                    </div>
                                </Col>
                            </Row>
                        </div> */}
                        {/* <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                            <h1 className="text-dark"><u>{article?.authors?.[0]?.author_name}</u></h1>
                        </div> */}
                        <div style={{ textAlign: 'center' }} className="mt-2">
                            <p style={{ fontWeight: 'bold' }}>{authorDetails?.name}</p>
                        </div>
                        <div>
                            <label> {(() => {
                                const parts = [];
                                if (authorDetails?.department && authorDetails.department.trim() !== '') {
                                    parts.push(authorDetails.department);
                                }
                                if (authorDetails?.college && authorDetails.college.trim() !== '') {
                                    parts.push(authorDetails.college);
                                }
                                if (authorDetails?.university_name_1 && authorDetails.university_name_1.trim() !== '') {
                                    parts.push(authorDetails.university_name_1);
                                }
                                if (authorDetails?.country && authorDetails.country.trim() !== '') {
                                    parts.push(authorDetails.country);
                                }
                                if (authorDetails?.designation && authorDetails.designation.trim() !== '') {
                                    parts.push(authorDetails.designation);
                                }
                                if (
                                    authorDetails?.telephone &&
                                    /^\d{7,}$/.test(authorDetails.telephone.trim())
                                ) {
                                    parts.push(authorDetails.telephone.trim());
                                }

                                if (authorDetails?.email_1 && authorDetails.email_1.trim() !== '') {
                                    parts.push(authorDetails.email_1);
                                }
                                if (authorDetails?.qualification && authorDetails.qualification.trim() !== '') {
                                    parts.push(authorDetails.qualification);
                                }
                                if (authorDetails?.address && authorDetails.address.trim() !== '') {
                                    parts.push(authorDetails.address);
                                }
                                return parts.join(', ');
                            })()}</label>
                        </div>
                        <div>
                            <h4 className="text-dark">Publications</h4>
                        </div>
                        <div className="card"
                            style={{
                                borderColor: 'lightgray',
                                backgroundColor: '#f8f9fa',
                                padding: 20,
                                borderRadius: 4
                            }}>
                            <strong style={{ fontSize: 15 }}>{article?.article_types?.[0]?.name} </strong>
                            <div>
                                <div>
                                    <Link
                                        to={type === "archive" ? `/${slug}/archive/${article?.slug}` : `/${slug}/article/${article?.slug}`}
                                        state={"article"}
                                    // target="_blank"
                                    >
                                        {article?.article_title}
                                    </Link>
                                </div>
                                <div> {authorDetails?.department ? authorDetails?.department + "," : ""}{authorDetails?.college ? authorDetails?.college + "," : ''}{authorDetails?.university_name_1 ? authorDetails?.university_name_1 + "," : ''}  {authorDetails?.country ? authorDetails?.country : ''}</div>
                            </div>

                            <div>
                                <>
                                    <b>Author(s): </b>
                                    <em style={{ textDecoration: 'underline', cursor: 'pointer' }}> {/* <em style={{ textDecoration: 'underline', cursor: 'pointer' }}>{article?.authors?.[0]?.author_name}*</em> */}
                                        {(() => {
                                            const affiliationMap = getAffiliationMap(article);
                                            return article?.authors?.map((item, indexData) => {
                                                const hasAffiliations = item?.author_anchor_affiliation?.length > 0;
                                                const isCorresponding = item?.author_type === "corresponding";
                                                return (
                                                    <Link key={indexData} onClick={() => handleAuthorDetails(item)}>
                                                        <em>
                                                            {item?.author_name}
                                                            {hasAffiliations && (() => {
                                                                const supNumbers = new Set();

                                                                item?.author_anchor_affiliation?.forEach((affiliationItem) => {
                                                                    const key = `${affiliationItem?.department}|${affiliationItem?.university_name_1}|${affiliationItem?.country}`;
                                                                    const affiliationData = affiliationMap.get(key);
                                                                    if (affiliationData) {
                                                                        supNumbers.add(affiliationData.number);
                                                                    }
                                                                });

                                                                const numbersArray = Array.from(supNumbers).sort((a, b) => a - b);
                                                                return numbersArray.length > 0 ? (
                                                                    <sup>
                                                                        <em>{numbersArray.join(",")}</em>
                                                                    </sup>
                                                                ) : null;
                                                            })()}
                                                            {isCorresponding && <sup>*</sup>}
                                                            {indexData < article?.authors?.length - 1 && ', '}
                                                        </em>
                                                    </Link>
                                                );
                                            });
                                        })()}
                                    </em>
                                </>

                            </div>
                            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                                {article?.doi &&
                                    <p><strong>DOI: </strong> {article?.doi}</p>
                                }
                            </div>
                            <div className="about-instructor">
                                <div >
                                    {article?.article_access_types === 'open access' ? (
                                        <Link
                                            to={type === "archive" ? `/${slug}/archive/${article?.slug}` : `/${slug}/article/${article?.slug}`}
                                            state={"article"}
                                        // target="_blank"
                                        >
                                            <img src={Html} alt="html" width="30" className="img-fluid" />
                                        </Link>
                                    ) : (
                                        <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                            <img src={Html} alt="html" width="30" className="img-fluid" />
                                        </span>
                                    )}
                                </div>
                                <div >
                                    {article?.article_access_types === 'open access' ? (
                                        <Link
                                            to={article?.pdf_url}
                                        // target="_blank"
                                        >
                                            <img
                                                src={Pdf}
                                                alt="img"
                                                className="img-fluid"
                                            />
                                        </Link>
                                    ) : (
                                        <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                            <img src={Pdf} alt="pdf" className="img-fluid" />
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                    </Col>

                </Row>
            </div>
            <Footer />
        </>
    )
}

export default AuthorInfoJournal